export const ADVANCE = 'TIMER_ADVANCE'
export const DELAY = 'TIMER_DELAY'
export const EXPIRE = 'TIMER_EXPIRE'
export const SET_EXPIRATION = 'TIMER_SET_EXPIRATION'
export const START = 'TIMER_START'
export const STOP = 'TIMER_STOP'
export const TICK = 'TIMER_TICK'

export const STEP = 500.0 // 500 millisecons

/**
 *  Advance some ticks the end of the timer.
 *  @param   {string}  timerId  Timer Identification.
 *  @param   {number}  ticks    Ticks to advance.
 */
export const advance = (timerId, ticks) => {
  return { type: ADVANCE, data: { id: timerId, ticks } }
}

/**
 *  Advance some seconds the end of the timer.
 *  @param   {string}  timerId  Timer Identification.
 *  @param   {number}  seconds  Seconds to advance.
 */
export const advanceSeconds = (timerId, seconds) => {
  const ticks = (seconds * 1000.0) / STEP
  return advance(timerId, ticks)
}

/**
 *  Delay some ticks the end of the timer.
 *  @param   {string}  timerId  Timer Identification.
 *  @param   {number}  ticks    Ticks to delay.
 */
export const delay = (timerId, ticks) => {
  return { type: DELAY, data: { id: timerId, ticks } }
}

/**
 *  Delay some seconds the end of the timer.
 *  @param   {string}  timerId  Timer Identification.
 *  @param   {number}  seconds  Seconds to delay.
 */
export const delaySeconds = (timerId, seconds) => {
  const ticks = (seconds * 1000.0) / STEP
  return delay(timerId, ticks)
}

/**
 *  Set the expiration of the timer idetified by timerId.
 *  @param {string} timerId Timer Identification.
 *  @param {number} ticks   Ticks until timer expiration.
 */
export const setExpiration = (timerId, ticks) => {
  return {
    type: SET_EXPIRATION,
    data: { id: timerId, ticks: ticks },
  }
}

/**
 *  Set the expiration seconds of the timer idetified by timerId.
 *  @param {string} timerId Timer Identification.
 *  @param {number} seconds Seconds until timer expiration.
 */
export const setExpirationSeconds = (timerId, seconds) => {
  const ticks = (seconds * 1000.0) / STEP
  return setExpiration(timerId, ticks)
}

/**
 *  Init the timer regresion.
 *  @param {string} timerId Timer Identification.
 */
export const start = (timerId) => {
  return { type: START, data: timerId }
}
export const stop = (timerId) => {
  return { type: STOP, data: timerId }
}
